<template>
  <div class="irt-select-container">
    <div class="irt-select-input-container">
      <input @focusin="onFocused(true)" @focusout="onFocused(false)" type="text" class="form-control w-100"
             :placeholder="placeholder" v-model="current" :disabled="disabled"
             v-on:keyup.enter="onEnter()" v-on:keyup.up="onUp()" v-on:keyup.down="onDown()">
      <div @click="onFocused(true)" v-if="!canBeCleared" class="irt-btn my-auto d-flex">
        <micon icon="expand_more" style="font-size: 1.5rem;color: #5A5F64"/>
      </div>
      <div @click="clear()" v-if="canBeCleared && current!=null && current!=''" class="irt-btn my-auto d-flex">
        <micon icon="cancel" class="material-icons-outlined"/>
      </div>
    </div>
    <div :ref="optionsRef">
      <div class="irt-dropdown irt-scroll" :class="isFocused?'irt-active':''">
        <div v-if="optionsEffective.length>0" style="background-color: #0000000a">
          <div class="pt-2" style="margin-left:0.6rem;font-weight: 600;font-size: 0.7rem;opacity: 0.6">Suggestions</div>
          <div v-for="(item,index) in optionsEffective" :key="index" :ref="item.value" class="irt-option irt-match"
               @click="onOptionClick(item)" @mouseover="onOptionHover(-1)">
            {{ item.display }}
          </div>
        </div>
        <div v-if="optionsEffective.length>0" class="irt-separator-horizontal my-2"></div>

        <div v-for="(item,index) in options" :key="index" :ref="item.value" class="irt-option"
             @click="onOptionClick(item)" @mouseover="onOptionHover(index)"
             :class="activeOption===index?'irt-active':''">
          {{ item.display }}
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "IrtSelect",
  props: {
    modelValue: {
      type: String, default: null
    },
    placeholder: {
      type: String, default: null
    },
    options: Array,
    canBeCleared: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["update:modelValue"],
  data() {
    return {
      activeOption: -1,
      current: null,
      isFocused: false,
      optionsEffective: [],
      optionsRef: Math.random().toString()
    };
  },
  methods: {
    clear() {
      this.current = null;
      this.$emit("update:modelValue", null);
    },
    onFocused(flag) {
      this.isFocused = flag;
    },
    onOptionClick(item) {
      this.current = item.display;
      this.$emit("update:modelValue", item.value);
    },
    scrollToTop() {
      const top = this.$refs[this.optionsEffective[0].value];
      if (top != null)
        top.scrollIntoView({behavior: 'smooth'});
    },
    scrollToActive() {
      this.$refs[this.options[this.activeOption].value].scrollIntoView({behavior: 'smooth'});
    },
    onUp() {
      if (this.activeOption <= 0)
        return;
      this.activeOption--;
      if (this.checkInView(this.options[this.activeOption].value) !== 0)
        this.scrollToActive();
    },
    onDown() {
      if (this.activeOption >= this.options.length - 1)
        return;
      this.activeOption++;
      const offset = this.checkInView(this.options[this.activeOption].value);
      if (offset !== 0)
        this.scrollToActive();
    },
    onEnter() {
      if (this.activeOption !== -1)
        return this.onOptionClick(this.options[this.activeOption]);
      this.onOptionClick({value: null, display: this.current})
    },
    onOptionHover(index) {
      this.activeOption = index;
    },
    checkInView(elementRef) {
      const container = this.$refs[this.optionsRef];
      const containerTop = container.getBoundingClientRect().top
      const containerBottom = containerTop + container.clientHeight;
      const element = this.$refs[elementRef];
      const elemTop = element.getBoundingClientRect().top - containerTop;
      if (elemTop < 0)
        return -1;

      const elemBottom = elemTop + element.clientHeight;
      if (elemBottom > containerBottom)
        return 1;
      return 0;
    },
  },

  created() {
    // this.optionsEffective = this.options.map(item => item);
    this.optionsEffective = [];
  },
  watch: {
    options() {
      // this.optionsEffective = this.options;
    },
    current(newValue, oldValue) {
      if (newValue === oldValue)
        return;
      this.optionsEffective = newValue != null && newValue !== ""
          ? this.options.filter(item => item.display.toLowerCase().includes(newValue.toLowerCase()))
          : [];
      this.activeOption = -1;
    },
    modelValue(n) {
      if (this.current === n)
        return;
      const match = this.options.filter(item => item.value === n);
      this.current = match.length > 0 ? match[0].display : null;
    }
  }
};

</script>